<template>
  <div class="disciplinaryMeasure">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row align-items-center">
              <div class="col">
                <h3 class="page-title">Disciplinary Measures</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item">
                    <router-link to="/index">Dashboard</router-link>
                  </li>
                  <li class="breadcrumb-item active">Disciplinary Measures</li>
                </ul>
              </div>
              <div class="col-auto float-right ml-auto">
                <a @click="openDialog" class="btn add-btn"
                  ><i class="fa fa-plus"></i> Add Disciplinary Measures</a
                >
              </div>
            </div>
          </div>
          <!-- /Page Header -->
          <!----Datatable-->
          <div class="row">
            <div class="col-md-12">
              <div class="table-responsive">
                <v-data-table
                  :headers="headers"
                  :items="disciplinaryMeasures"
                  sort-by=""
                  class="elevation-1"
                >
                  <template v-slot:[`item.actions`]="{ item }">
                    <div class="dropdown dropdown-action">
                      <a
                        href="#"
                        class="action-icon dropdown-toggle"
                        data-toggle="dropdown"
                        aria-expanded="false"
                        ><i class="material-icons">more_vert</i></a
                      >
                      <div class="dropdown-menu dropdown-menu-right">
                        <a
                          class="dropdown-item"
                          @click="setEditDisciplinaryMeasure(item)"
                          ><i class="fa fa-pencil m-r-5"></i> Edit</a
                        >
                        <a
                          class="dropdown-item"
                          @click="setDeleteDisciplinaryMeasure(item)"
                          ><i class="fa fa-trash-o m-r-5"></i> Delete</a
                        >
                      </div>
                    </div>
                  </template>
                  <template v-slot:[`item.profile`]="{ item }">
                    <h2 class="table-avatar blue-link">
                      <router-link to="/profile">{{
                        `${item.employee.firstName} ${item.employee.lastName}`
                      }}</router-link>
                    </h2>
                  </template>
                  <template v-slot:[`item.reas`]="{ item }">
                    {{ item.reason | truncate(150, "...") }}
                  </template>
                  <template v-slot:[`item.for`]="{ item }">
                    {{
                      item.form == 1
                        ? "Query"
                        : item.form == 2
                        ? "Warning"
                        : item.form == 3
                        ? "Suspension"
                        : "Surcharge"
                    }}
                  </template>
                </v-data-table>
              </div>
            </div>
          </div>
          <!---/Datatable-->
        </div>
        <!-- /Page Content -->

        <!-- Add disciplinaryMeasure Modal -->
        <v-dialog v-model="dialog" max-width="725px">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Add Disciplinary Measures</h5>
              <button type="button" class="close" @click="close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-md-12">
                  <div
                    class="alert alert-danger alert-dismissible fade show"
                    role="alert"
                    v-if="error"
                  >
                    <strong>Error!</strong> {{ error }}
                    <button
                      type="button"
                      class="close"
                      data-dismiss="alert"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                </div>
                <div class="col-md-12">
                  <div
                    class="alert alert-success alert-dismissible fade show"
                    role="alert"
                    v-if="message"
                  >
                    <strong>Success!</strong> {{ message }}
                    <button
                      type="button"
                      class="close"
                      data-dismiss="alert"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                </div>
              </div>
              <form @submit.prevent="onSubmit">
                <div class="form-group">
                  <label>Employee<span class="text-danger">*</span></label>
                  <multiselectvue
                    class="from-control"
                    v-model="employeeName"
                    placeholder="Select Employee"
                    :custom-label="nameOfEmployee"
                    :options="sortedEmployeeNames"
                    :searchable="true"
                    @select="optionSelected"
                    :allow-empty="false"
                  >
                    <template slot="singleLabel" slot-scope="{ option }"
                      >{{ option.firstName }} {{ option.lastName }}</template
                    >
                  </multiselectvue>
                  <!--
                  <select
                    class="form-control"
                    v-model="employeeId"
                    @change="getEmployeeQueries"
                  >
                    <option>Select Employee</option>
                    <option
                      v-for="item in employees"
                      :key="item.id"
                      :value="item.id"
                      >{{ item.firstName + " " + item.lastName }}</option
                    >
                  </select> -->
                </div>
                <div class="form-group">
                  <label>Date <span class="text-danger">*</span></label>
                  <div class="cal-icon">
                    <datepicker
                      v-model="date"
                      calendar-class
                      input-class
                      bootstrap-styling
                      class="form-control datetimepicker"
                      type="text"
                    />
                  </div>
                </div>
                <div class="form-group">
                  <label>Form <span class="text-danger">*</span></label>
                  <select class="select form-control" v-model="form">
                    <option>-- Select --</option>
                    <option :value="1">Query</option>
                    <option :value="2">Warning</option>
                    <option :value="3">Suspension</option>
                    <option :value="4">Surcharge</option>
                  </select>
                </div>
                <div class="form-group" v-if="form === 4">
                  <label>Surchage Amount <span class="text-danger">*</span></label>
                  <input
                      v-model="surchargeAmount"
                      class="form-control"
                      type="text"
                    />
                </div>
                <div class="form-group" v-if="form === 3">
                  <label>Suspension Days <span class="text-danger">*</span></label>
                  <input
                      v-model="suspensionDays"
                      class="form-control"
                      type="text"
                    />
                </div>
                <div class="form-group" v-if="form === 3">
                  <label>Suspension Start Date <span class="text-danger">*</span></label>
                  <div class="cal-icon">
                    <datepicker
                      v-model="suspensionStartDate"
                      calendar-class
                      input-class
                      bootstrap-styling
                      class="form-control datetimepicker"
                      type="text"
                    />
                  </div>
                </div>
                <div class="form-group" v-if="form === 3">
                  <label>Suspension End Date <span class="text-danger">*</span></label>
                  <div class="cal-icon">
                    <datepicker
                      v-model="suspensionEndDate"
                      calendar-class
                      input-class
                      disabled
                      bootstrap-styling
                      class="form-control datetimepicker"
                      type="text"
                    />
                  </div>
                </div>
                <div class="form-group">
                  <label>Reason <span class="text-danger">*</span></label>
                  <textarea
                    class="form-control"
                    v-model="reason"
                    rows="4"
                  ></textarea>
                </div>
                <div class="form-group">
                  <label>Final Remark <span class="text-danger">*</span></label>
                  <textarea
                    class="form-control"
                    v-model="remark"
                    rows="4"
                  ></textarea>
                </div>
                <div class="submit-section">
                  <button
                    data-dismiss="modal"
                    class="btn btn-primary submit-btn"
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </v-dialog>
        <!-- /Add disciplinaryMeasure Modal -->

        <!-- Edit disciplinaryMeasure Modal -->
        <v-dialog v-model="dialogEdit" max-width="725px">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Edit Disciplinary Measure</h5>
              <button type="button" class="close" @click="closeEdit">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form @submit.prevent="updateDisciplinaryMeasure">
                <div class="form-group">
                  <label>Employee <span class="text-danger">*</span></label>
                  <select
                    class="form-control"
                    v-model="disciplinaryMeasure.employeeId"
                  >
                    <option>Select Employee</option>
                    <option
                      v-for="item in employees"
                      :key="item.id"
                      :value="item.id"
                      >{{ item.firstName + " " + item.lastName }}</option
                    >
                  </select>
                </div>
                <div class="form-group">
                  <label>Date <span class="text-danger">*</span></label>
                  <div class="cal-icon">
                    <datepicker
                      v-model="disciplinaryMeasure.date"
                      calendar-class
                      input-class
                      bootstrap-styling
                      class="form-control datetimepicker"
                      type="text"
                    />
                  </div>
                </div>

                <!-- <div class="form-group">
                      <label>Form <span class="text-danger">*</span></label>
                      <input class="form-control" v-model="disciplinary.form" />
                  </div> -->
                <div class="form-group">
                  <label>Form <span class="text-danger">*</span></label>
                  <select
                    class="select form-control"
                    v-model="disciplinaryMeasure.form"
                  >
                    <option>-- Select --</option>
                    <option :value="1">Query</option>
                    <option :value="2">Warning</option>
                    <option :value="3">Suspension</option>
                    <option :value="4">Surcharge</option>
                  </select>
                </div>
                <div class="form-group">
                  <label>Reason <span class="text-danger">*</span></label>
                  <textarea
                    class="form-control"
                    v-model="disciplinaryMeasure.reason"
                    rows="4"
                  ></textarea>
                </div>
                <div class="form-group">
                  <label>Remark <span class="text-danger">*</span></label>
                  <textarea
                    class="form-control"
                    v-model="disciplinaryMeasure.remark"
                    rows="4"
                  ></textarea>
                </div>
                <div class="submit-section">
                  <button class="btn btn-primary submit-btn">Submit</button>
                </div>
              </form>
            </div>
          </div>
        </v-dialog>
        <!-- /Edit disciplinaryMeasure Modal -->

        <!-- Delete disciplinaryMeasure Modal -->
        <v-dialog v-model="dialogDelete" max-width="725px">
          <div class="modal-content">
            <div class="modal-body">
              <div class="form-header">
                <button type="button" class="close" @click="closeDelete">
                  <span aria-hidden="true">&times;</span>
                </button>
                <h3>Delete disciplinaryMeasure</h3>
                <p>Are you sure want to delete?</p>
              </div>
              <div class="modal-btn delete-action">
                <div class="row">
                  <div class="col-6">
                    <a
                      @click.prevent="deleteDisciplinaryMeasure"
                      class="btn btn-primary continue-btn"
                      data-dismiss="modal"
                      >Delete</a
                    >
                  </div>
                  <div class="col-6">
                    <a
                      href="javascript:void(0);"
                      data-dismiss="modal"
                      @click="closeDelete"
                      class="btn btn-primary cancel-btn"
                      >Cancel</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-dialog>
        <!-- /Delete disciplinaryMeasure Modal -->
      </div>
      <!-- /Page Wrapper -->
    </div>
  </div>
</template>
<script>
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";
import { required, sameAs } from "vuelidate/lib/validators";
import { employeeService } from "@/services/employeeService.js";
import Datepicker from "vuejs-datepicker";
import { authenticationService } from "@/services/authenticationService";

export default {
  components: {
    LayoutHeader,
    LayoutSidebar,
    Datepicker
  },

  data() {
    return {
      dialog: false,
      dialogEdit: false,
      dialogDelete: false,
      headers: [
        // {
        //   text: 'Form',
        //   align: 'start',
        //   value: 'profile',
        // },
        { text: "Form", value: "for" },
        { text: "Reason", value: "reas" },
        { text: "Accused Employee", value: "profile" },
        // { text: 'Status Reason', value: 'reason' },
        { text: "Designation", value: ".employee.designation.name" },
        { text: "Actions", value: "actions", sortable: false }
      ],
      name: "",
      form: 0,
      employeeId: "",
      queryId: 0,
      hrManager: "",
      reason: "",
      remark: "",
      date: "",
      surchargeAmount: 0,
      suspensionDays: 0,
      suspensionStartDate: "",
      // suspensionEndDate: "",
      disciplinaryMeasure: {
        query: {}
      },
      disciplinaryMeasures: [],
      employee: {},
      loading: false,
      error: "",
      employees: [],
      employeeName: "",
      submitted: false,
      queries: [],
      message: "",
      error: "",
      //employee: authenticationService.currentOfficeValue,
      company: authenticationService.currentOfficeValue,
      user: authenticationService.currentUserValue
    };
  },

  validations: {
    name: { required },
    reason: { required },
    form: { required },
    date: { required }
    //disciplinaryMeasureDate: { required },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    dialogEdit(val) {
      val || this.closeEdit();
    }
  },

  computed: {
    sortedEmployeeNames: function() {
      function compare(a, b) {
        if (a.firstName.toLowerCase() < b.firstName.toLowerCase()) return -1;
        if (a.firstName.toLowerCase() > b.firstName.toLowerCase()) return 1;
        return 0;
      }

      return this.employees ? this.employees.sort(compare) : this.employees;
    },
    suspensionEndDate () {
      if (this.suspensionStartDate !== '' && this.suspensionStartDate) {
        const startDate = new Date(this.suspensionStartDate);
        const endDate = new Date(startDate);
        console.log('start', startDate)
        console.log('end', endDate)
        endDate.setDate(startDate.getDate() + parseInt(this.suspensionDays));
        console.log('day Set :>>', startDate.getDate())
        console.log('added days >>', startDate.getDate() + parseInt(this.suspensionDays))

        const formDate = endDate.toISOString();
        console.log('final', formDate)
        return formDate
      }
    }
  },
  methods: {
    nameOfEmployee({ firstName, lastName }) {
      return `${firstName} ${lastName}`;
    },

    optionSelected(option, id) {
      console.log(option.id, this.employeeId);
      this.employeeId = option.id;
    },
    // getEmployees(id) {
    //   employeeService.getEmployees(id).then(
    //     (model) => {
    //       console.log(model);
    //       this.employees = model;
    //     },
    //     (error) => {
    //       error = error;
    //     }
    //   );
    // },
    getEmployees() {
      var unit = JSON.parse(localStorage.getItem("companyUnit"));
      employeeService.getEmployees(unit.id).then(
        model => {
          this.employees = model;
          // console.log(model)
        },
        error => {
          error = error;
        }
      );
    },
    openDialog() {
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      this.clearList();
    },
    closeEdit() {
      this.dialogEdit = false;
    },
    closeDelete() {
      this.dialogDelete = false;
    },
    clearList() {
      this.employeeId = "";
      this.date = "";
      this.form = "";
      this.reason = "";
      this.remark = "";
      this.suspensionDays = 0;
      this.suspensionStartDate = ""
      this.surchargeAmount = 0;
      this.message = "";
      this.error = "";
    },
    setEditDisciplinaryMeasure(model) {
      this.disciplinaryMeasure = model;
      this.dialogEdit = true;
    },
    setDeleteDisciplinaryMeasure(model) {
      this.disciplinaryMeasure = model;
      this.dialogDelete = true;
    },
    getDisciplinaryMeasures() {
      //const user = this.user;
      // console.log(`company`, this.company.id)
      employeeService.getDisciplinaryMeasures(this.company.id).then(
        model => {
          this.disciplinaryMeasures = model;
          // console.log(`model`, model)
        },
        error => {
          error = error;
        }
      );
    },
    onSubmit() {
      this.submitted = true;

      this.loading = true;
      if (this.reason == "" && this.remark == "") {
        this.error = "fill all fields";
        return;
      }
      const req = {
        date: this.date,
        form: this.form,
        surchargeAmount: parseFloat(this.surchargeAmount),
        suspensionDays: this.suspensionDays,
        suspensionStartDate: this.suspensionStartDate,
        reason: this.reason,
        remark: this.remark,
        employeeId: this.employeeId
      }
      employeeService
        .addDisciplinaryMeasure(req)
        .then(
          id => {
            this.message = "Discipllinary measure added successfully";
            employeeService.getDisciplinaryMeasures(this.company.id).then(w => {
              this.disciplinaryMeasures = w;
              // console.log(w);
              this.close();
            });
          },
          error => {
            this.error = error;
            this.loading = false;
          }
        );
    },
    updateDisciplinaryMeasure() {
      this.submitted = true;

      this.loading = true;
      // console.log(this.disciplinaryMeasure)
      employeeService
        .updateDisciplinaryMeasure(
          this.disciplinaryMeasure.id,
          this.disciplinaryMeasure.date,
          this.disciplinaryMeasure.form,
          this.disciplinaryMeasure.reason,
          this.disciplinaryMeasure.remark,
          this.disciplinaryMeasure.employeeId
        )
        .then(
          id => {
            employeeService.getDisciplinaryMeasures(this.company.id).then(o => {
              (this.disciplinaryMeasures = o),
                //console.log(o),
                this.closeEdit();
            });
          },
          error => {
            this.error = error;
            this.loading = false;
          }
        );
    },
    deleteDisciplinaryMeasure() {
      const id = this.disciplinaryMeasure.id;
      // console.log(this.disciplinaryMeasure)
      employeeService.removeDisciplinaryMeasure(id).then(id => {
        employeeService.getDisciplinaryMeasures(this.company.id).then(
          model => {
            this.disciplinaryMeasures = model;
            // console.log(model)
            this.closeDelete();
          },
          error => {
            error = error;
          }
        );
      });
    }
  },

  mounted() {
    this.getEmployees();
    this.getDisciplinaryMeasures();
    // Datatable
    //this.getEmployees(this.employee.id);
    //this.getEmployeedisciplinaryMeasures(this.company.id);

    if ($(".datatable").length > 0) {
      $(".datatable").DataTable({
        bFilter: false
      });
    }
    // Date Time Picker

    if ($(".datetimepicker").length > 0) {
      $(".datetimepicker").datetimepicker({
        format: "DD/MM/YYYY",
        icons: {
          up: "fa fa-angle-up",
          down: "fa fa-angle-down",
          next: "fa fa-angle-right",
          previous: "fa fa-angle-left"
        }
      });
    }

    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function(e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "disciplinarymeasures"
};
</script>



// WEBPACK FOOTER //
// src/components/discipline/disciplinaryMeasures.vue